import React from 'react';
import { Church } from 'lucide-react';
import { NAVIGATION_TABS, CHURCH_INFO } from '../config/constants';
import { useAuth } from '../context/AuthContext';

const Header = ({ activeTab, setActiveTab }) => {
  const { isAuthenticated } = useAuth();

  // Filter tabs based on authentication status
  const visibleTabs = NAVIGATION_TABS.filter(tab =>
    !tab.adminOnly || (tab.adminOnly && isAuthenticated)
  );
  return (
    <header className="header">
      <nav className="header-nav">
        <div className="header-container">
          <div className="header-logo">
            <Church size={32} />
            <span>{CHURCH_INFO.name}</span>
          </div>

          <div className="header-nav-buttons">
            {visibleTabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`nav-button ${activeTab === tab.id ? 'active' : ''}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;